import { QueryConsumer } from './QueryConsumer'
import { reducer } from "./reducer/query-consumer";

export default {
	QueryConsumer,
	reducer
}